<template>
  <div>
    <div v-if="!this.loading"
         class="card  bg-transparent">
      <div v-if="!this.display_aggrid">
        <div class="border-0 card-header bg-white">
          <h3 class="mb-0">Existing Configuration</h3>
        </div>
        <el-table class="table-responsive"
                  header-row-class-name="thead-light"
                  :data="this.tabs_config.content">
          <el-table-column label="Search"
                           min-width="150px"
                           prop="Search"
          >
            <template v-slot="{row}">
              <b>{{row.reports[0]['configuration_name']}}</b>
            </template>
          </el-table-column>
          <el-table-column label="Last run"
                           prop="Last run"
                           min-width="140px"
                           sortable>
            <template v-slot="{row}">
              <b>{{row.reports[0]['date last run']}}</b>
            </template>
          </el-table-column>
          <el-table-column label="Action"
                           min-width="150px"
                           prop="Type"
          >
            <template v-slot="{row}">
              <b>{{row.reports[0]['action']}}</b>
            </template>
          </el-table-column>
          <el-table-column label="Aquired"
                           min-width="110px"
                           prop="number_of_connections"
                           sortable>
            <template v-slot="{row}">
              <b>{{row.reports[0]['accepted']}}</b>
            </template>
          </el-table-column>

          <el-table-column label="status"
                           min-width="150px"
                           prop="status"
                           sortable>
            <template v-slot="{row}">
              <b>{{row.reports[0]['configuration_state']}}</b>
            </template>
          </el-table-column>
          <el-table-column label="On/Off"
                           min-width="100px"
                           prop="On/Off"
          >
            <template v-slot="{row}">
              <base-switch on-text="On" off-text="Off"
                           :key="update_key_switch"
                           :value="switchesBased[row.checked]"
                           min-width="100px"
                           @input="check((row.checked==='On' ? 'Off' : 'On'),row.reports[0],row.reports[0].id_argon)"
              ></base-switch>

            </template>
          </el-table-column>


          <el-table-column min-width="180px" align="center">
            <div slot-scope="{row}" class="table-actions">
              <b-spinner v-if="row.reports[0].spinner_state==='true'" small :variant="'info'"
                         :key="'info'" label="Loading..."></b-spinner>
              <el-tooltip content="Download Contact Information" placement="top">
                <a @click.prevent="exportContact(row.reports[0])" class="table-action"
                   data-toggle="tooltip"
                   data-original-title="Download Contact">
                  <i class="fas fa-file-download"></i>
                </a>
              </el-tooltip>
              <el-tooltip content="Edit" placement="top">
                <a @click.prevent="onEdit(row)" class="table-action" data-toggle="tooltip"
                   data-original-title="Edit configuration">
                  <i class="fas fa-user-edit"></i>
                </a>
              </el-tooltip>
              <!--              <el-tooltip content="Archive" placement="top">-->
              <!--                <a @click.prevent="onDelete(row)" class="table-action table-action-delete"-->
              <!--                   data-toggle="tooltip"-->
              <!--                   data-original-title="Archive Configuration">-->
              <!--                  <i class="fas fa-trash"></i>-->
              <!--                </a>-->
              <!--              </el-tooltip>-->
              <el-tooltip content="Display Contact Information" placement="top">
                <a @click.prevent="ShowGridView(row)" class="table-action"
                   data-toggle="tooltip"
                   data-original-title="Display Contact Information">
                  <i class="fas fa-arrow-right"></i>
                </a>
              </el-tooltip>
            </div>
          </el-table-column>

        </el-table>
        <modal :show.sync="stateModalConfigurationInstagramArgon" @close="closeArgonModal()">
          <template slot="header">
            <h5 class="modal-title" id="ConfigurationDetail">Configuration detail</h5>
          </template>
          <div>
            <label>Configuration running on the following instagram email
              <b>{{modalEmailInstagramTmpArgon}}</b></label>

            <label>Tags Used in this configuration</label>
            <tags-input v-model="modalTagsInstagramArgon"></tags-input>
          </div>
          <template slot="footer">
            <base-button type="secondary" @click="closeArgonModal()">Close
            </base-button>
          </template>
        </modal>
        <modal :show.sync="checkConfigurationLimit"
               @close="checkConfigurationLimit = false"
               danger>
          <template slot="header">
            <h5 class="modal-title">Configuration Limit</h5>
          </template>
          <div>You already reached the limit of active configuration of type <span
            style="color:red;">{{tmpModeForCheckLimit}}</span>, for the sake of your
            linkedIn
            accounts, to keep it under the radar you can only have one configuration of the same
            type
            active at once:
            <ul>
              <li>Nbr of active configuration for <i>{{tmpModeForCheckLimit}}</i>:
                {{actualCountConfiguration}}
              </li>
              <li>Limit for type <i>{{tmpModeForCheckLimit}}</i>:
                {{limit_configuration}}
              </li>
            </ul>
            <p style="font-size: 12px;padding-top: 5%;margin-bottom: -5%">Have any question on
              those
              limits? contact your <a href="mailto:support@yoursynchronicity.com">Administrator</a></p>
          </div>
          <template slot="footer">
            <base-button type="secondary" @click="checkConfigurationLimit = false">Close
            </base-button>
            <!--        <mdb-btn color="primary">Save changes</mdb-btn>-->
          </template>
        </modal>
      </div>
      <div v-else>
        <card>
          <i class="fas fa-arrow-left fa-2x" @click="display_aggrid=false"></i>
          <display-contact-information
            :column-defs="columnDefs" :row-data="rowData">
          </display-contact-information>
        </card>
      </div>
    </div>

    <div v-if="this.loading">
      <div class="spinner-grow" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

  </div>
</template>
<script>
    // import users from './../users'
    import {Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip} from 'element-ui'
    import axios from "axios";
    import VueLoadingButton from 'vue-loading-button'
    import DisplayContactInformation from "../commons/DisplayContactInformation";
    import {eventBus} from '../../main'
    import TagsInput from '../Argon/Inputs/TagsInput'

    export default {
        name: 'ConfigTableInstagram',
        components: {
            VueLoadingButton,
            eventBus,
            TagsInput,
            DisplayContactInformation,
            [Tooltip.name]: Tooltip,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
        },
        data() {
            return {
                ///AgGrid//
                display_aggrid: false,
                columnDefs: [],
                rowData: null,
                /////////
                ///YSY///
                update_key_switch: '',
                switchesBased:
                    {
                        'On': true,
                        'Off': false
                    },
                modalEmailInstagramTmpArgon: [],
                modalTagsInstagramArgon: [],
                stateModalConfigurationInstagramArgon: false,
                checkConfigurationLimit: false,
                tempValue: null,
                tmpModeForCheckLimit: '',
                limit_configuration: '',
                actualCountConfiguration: '',
                editing:
                    {
                        "pipedrive token":
                            false, "message_1":
                            false, "message_2":
                            false
                    }
                ,
                isLoadingButton: false,
                isStyledButton:
                    false,
                loading:
                    true,
                search_status:
                    false,
                dictConfigurationLimit:
                this.$store.getters.getDictConfigurationLimit,
                tabs_config:
                    {
                        content: []
                    }
                ,
                /////////
                // users,
                currentPage: 1
            }
                ;
        },
        methods: {
            closeArgonModal() {
                this.stateModalConfigurationInstagramArgon = false;

            },

            getMapValue(obj, key) {
                if (obj.hasOwnProperty(key))
                    return obj[key];
                throw new Error("Invalid map key.");
            },

            async exportContact(report) {
                console.log('report', report);
                const path = this.BACKEND_YSY + "/instagram/get-user-configuration";
                let headers = {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.id_token}`
                };
                this.isLoadingButton = true;
                report["spinner_state"] = 'true';
                const payload_conf = {
                    username: this.$store.getters.getUser,
                    action: report['action'],
                    configuration_name: report['configuration_name'],
                    email_instagram: report['email_instagram'],
                    download: true,
                };
                await this.$http
                    .post(path, payload_conf, {headers})
                    .then(res => {
                        console.log(res.data)
                        let dictKey = payload_conf['username'] + "_" + payload_conf['email_instagram'] + "_" + payload_conf['configuration_name'] + "_" + payload_conf['action'];
                        let fileLink = document.createElement('a');
                        fileLink.href = res.data[dictKey];
                        document.body.appendChild(fileLink);
                        fileLink.click();
                        this.isLoadingButton = false;
                        report["spinner_state"] = 'false';
                    })
                    .catch(async error => {
                        // eslint-disable-next-line
                        const self = this;
                        if (error.response.status === 401) {
                            console.error('Unauthorized', error.response.data);
                            await this.refreshIdToken().then(function (result) {
                                console.log("res promise", result); // "Stuff worked!"
                                self.exportContact(report);
                            }, function (err) {
                                console.log("it broke", err); // Error: "It broke"
                                self.$router.push({name: 'login'});
                            });
                        }
                    });
            },
            check(event, report, index) {
                if (event === 'On' && this.tabs_config.content[index]['checked'] === 'Off') {
                    const mode = report['type']
                    // console.log('--------', this.dictConfigurationLimit[mode])
                    // if (this.dictConfigurationLimit[mode]['count'] >= this.dictConfigurationLimit[mode]['limit']) {
                    //     this.tmpModeForCheckLimit = mode;
                    //     this.actualCountConfiguration = this.dictConfigurationLimit[mode]['count'];
                    //     this.limit_configuration = this.dictConfigurationLimit[mode]['limit'];
                    //     console.log('Rejecting the demand');
                    //     this.checkConfigurationLimit = true;
                    //     this.tabs_config.content[index]['checked'] = 'Off'
                    //     this.update_key_switch = Date.now()
                    //     return
                    // }
                    // this.$store.commit('changeDictConfigurationLimit', {
                    //     'mode': mode,
                    //     'previous': this.dictConfigurationLimit[mode].count,
                    //     'rule': '+'
                    // });
                    this.checkResume(report, index)
                }
                if (event === 'Off' && this.tabs_config.content[index]['checked'] === 'On') {
                    console.log('offf')
                    // this.$store.commit('changeDictConfigurationLimit', {
                    //     'mode': this.tabs_config.content[index].reports[0]['type'],
                    //     'previous': this.dictConfigurationLimit[this.tabs_config.content[index].reports[0]['type']].count,
                    //     'rule': '-'
                    // })
                    this.checkPause(report, index)
                }
            },
            checkResume(report, index) {
                console.log(report, index)
                this.tabs_config.content[index].reports[0]['configuration_state'] = 'active'
                this.controlStateSearch(this.tabs_config.content[index]['searchId'], 'active')
                this.tabs_config.content[index]['checked'] = 'On'
            },
            checkPause(report, index) {
                console.log(report, index)
                this.tabs_config.content[index].reports[0]['configuration_state'] = 'not_active'
                this.controlStateSearch(this.tabs_config.content[index]['searchId'], 'not_active')
                this.tabs_config.content[index]['checked'] = 'Off'
            },
            async controlStateSearch(savedSearchId, state) {
                const path = this.BACKEND_YSY + "/instagram/get-user-configuration";
                let headers = {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.id_token}`
                };
                await this.$http
                    .post(path, {
                        username: this.$store.getters.getUser,
                        search_id: savedSearchId,
                        controle_state_search: 'true',
                        state: state,
                    }, {headers})
                    .then(res => {
                        console.log(res)
                    })
                    .catch(async error => {
                        const self = this;
                        if (error.response.status === 401) {
                            console.error('Unauthorized', error.response.data);
                            await this.refreshIdToken().then(function (result) {
                                console.log("res promise", result); // "Stuff worked!"
                                self.controlStateSearch(savedSearchId, state);
                            }, function (err) {
                                console.log("it broke", err); // Error: "It broke"
                                self.$router.push({name: 'login'});
                            });
                        }
                    });
            },
            // async archiveSearch(event) {
            //     const path = this.BACKEND_YSY + "/instagram/get-user-configuration";
            //     let headers = {
            //         'Content-type': 'application/json',
            //         'Authorization': `Bearer ${localStorage.id_token}`
            //     };
            //     await this.$http.post(path, {
            //         username: this.$store.getters.getEmailLinkedin,
            //         search_id: event['saved_search_Id'],
            //         archive: true
            //     }, {headers})
            //         .then(res => {
            //             console.log(res)
            //             location.reload()
            //         })
            //         .catch(async error => {
            //             const self = this;
            //             if (error.response.status === 401) {
            //                 console.error('Unauthorized', error.response.data);
            //                 await this.refreshIdToken().then(function (result) {
            //                     console.log("res promise", result); // "Stuff worked!"
            //                     self.archiveSearch(event);
            //                 }, function (err) {
            //                     console.log("it broke", err); // Error: "It broke"
            //                     self.$router.push({name: 'login'});
            //                 });
            //             }
            //         });
            // },
            getMessageConfig() {
                const path = this.BACKEND_YSY + "/instagram/get-user-configuration";
                let headers = {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.id_token}`
                };
                this.$http.post(path, {
                    username: this.$store.getters.getUser
                }, {headers})
                    .then(res => {
                        console.log(res)
                        if (res.data.search_status === 404) {
                            this.search_status = false;
                            this.loading = false;
                            return
                        }
                        if (res.status === 200) {
                            for (let i = 0; i < Object.keys(res.data).length; i++) {

                                if (res.data[i]['reports'][0]['configuration_state'] === 'active') {
                                    res.data[i]['checked'] = 'On';
                                    this.tabs_config.content.push(res.data[i]);
                                }
                                if (res.data[i]['reports'][0]['configuration_state'] === 'not_active') {
                                    res.data[i]['checked'] = 'Off';
                                    this.tabs_config.content.push(res.data[i]);
                                }

                            }
                            this.loading = false
                            this.search_status = true
                        }

                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        this.$router.push({name: 'login'});
                    });
            },
            onEdit(row) {
                console.log("myrow", row.reports[0])
                this.stateModalConfigurationInstagramArgon = true;
                this.modalTagsInstagramArgon = JSON.parse(row.reports[0].tags);
                this.modalEmailInstagramTmpArgon = row.reports[0]['email_instagram']
                console.log(this.ReportModalConfigurationArgon)

            },
            onDelete(row) {
                alert(`You want to delete ${row.name}`)
            },
            ShowGridView(row) {
                if (localStorage.influencers_information) {
                    console.log('No need for axios - contact_information in local store');
                    let TmpContactInformation = JSON.parse(localStorage.influencers_information);
                    console.log('TmpContactInformation', TmpContactInformation)
                    this.rowData = TmpContactInformation[row['searchId']];
                    this.display_aggrid = true;
                    return
                }

                console.log('axios call - Load data into locat store');
                const path = this.BACKEND_YSY + "/instagram/get-user-configuration";
                let headers = {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.id_token}`
                };
                this.$http
                    .post(path, {
                        username: this.$store.getters.getUser,
                        AgGridVue: true,
                    }, {headers})
                    .then(res => {
                        console.log('res.data', res);
                        localStorage.influencers_information = JSON.stringify(res.data);
                        this.rowData = res.data[row['searchId']];
                        console.log('this.rowData', this.rowData);
                        Object.entries(this.rowData[0]).forEach(([key, value]) => {
                            this.columnDefs.push({
                                headerName: key,
                                field: key,
                                sortable: true,
                                filter: true
                            })
                        });

                        eventBus.$emit('rowDataAgGrid', this.rowData);

                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                        const self = this;
                        self.$router.push({name: 'login'});
                    });
                this.display_aggrid = true;
            },
        },
        created() {
            this.dictConfigurationLimit = this.$store.getters.getDictConfigurationLimit
            this.getMessageConfig();
            console.log(this.tabs_config)
        }
    };
</script>
